import {
  EuiText,
  EuiBadge,
  EuiSelectableTemplateSitewide,
  EuiFlexGroup,
  EuiFlexItem,
  EuiLink,
  EuiButton,
} from '@elastic/eui';
import React, { useState, useEffect } from 'react';
import { EuiFieldSearch, EuiSuperSelect } from 'stable-eui';
import { noop } from 'lodash';
import { getMessage } from 'utils';
import LocalStorage from 'utils/LocalStorage';

export default ({ handleGlobalSearch, modalType }) => {
  const [searchValue, setSearchValue] = useState('');
  const [isLoading, setLoading] = useState(false);
  const [searchRef, setSearchRef] = useState(null);
  const searchValueExists = searchValue && searchValue.length;
  const superSelectOptions = [
    {
      value: 'PHIEU_GUI',
      inputDisplay: getMessage('pages.warehouse.common.tracking_code'),
      dropdownDisplay: <strong>{getMessage('pages.warehouse.common.tracking_code')}</strong>,
    },
    {
      value: 'TUI_THU',
      // disabled: true,
      inputDisplay: getMessage('layout.search.packinglist.title'),
      dropdownDisplay: <strong>{getMessage('layout.search.packinglist.title')}</strong>,
    },
    {
      value: 'CHUYEN_THU',
      disabled: true,
      inputDisplay: getMessage('layout.search.shipment.title'),
      dropdownDisplay: <strong>{getMessage('layout.search.shipment.title')}</strong>,
    },

    {
      value: 'BUU_CUC',
      disabled: true,
      inputDisplay: getMessage('layout.search.warehouse_code.title'),
      dropdownDisplay: <strong>{getMessage('layout.search.warehouse_code.title')}</strong>,
    },
  ];
  const [superSelectvalue, setSuperSelectValue] = useState(modalType || 'PHIEU_GUI');
  const [searchText, setSearchText] = useState(localStorage.getItem('globalSearchText') || '');
  const [historySearch, setHistorySearch] = useState(
    JSON.parse(localStorage.getItem('historySearchJson')) || []
  );

  const onSearch = (searchInput = null, typeInput = null) => {
    if (!searchInput && !searchText) return;
    const dataSearch = searchInput || searchText;
    const typeSearch = typeInput || superSelectvalue;
    const t = String(dataSearch).replace(/\r\n|\s+|\\t|\n|。|\t|\r/gi, '');
    console.log(t, typeSearch);

    setLoading(true);
    handleGlobalSearch({ type: typeSearch, searchText: t })
      .catch(noop)
      .finally(() => {
        setLoading(false);
      });
  };

  const onSuperSelectChange = (value) => {
    setSuperSelectValue(value);
  };

  /**
   * Timeout to simulate loading (only on key command+k)
   */
  let searchTimeout;
  const startSearchTimeout = () => {
    searchTimeout = setTimeout(() => {
      // Simulate a remotely-executed search.
      setLoading(false);
    }, 400);
  };
  clearTimeout(searchTimeout);
  startSearchTimeout();

  /**
   * Take the first 5 options and simulate recently viewed
   */

  const searchData = historySearch;
  const recents = searchData.slice(0, 5);
  const recentsWithIcon = recents.map((recent) => {
    return {
      ...recent,
      icon: {
        type: 'clock',
        color: 'subdued',
      },
    };
  });

  /**
   * Hook up the keyboard shortcut for command+k to initiate focus into search input
   */
  useEffect(() => {
    window.addEventListener('keydown', onWindowKeyDown);

    return function cleanup() {
      window.removeEventListener('resize', onWindowKeyDown);
    };
  });

  const onWindowKeyDown = (e) => {
    if (e.metaKey && e.key.toLowerCase() === 'k') {
      window.addEventListener('keyup', onWindowKeyUp);
    }
  };

  const onWindowKeyUp = () => {
    searchRef && searchRef.focus();
    setLoading(true);
    window.removeEventListener('keyup', onWindowKeyUp);
  };

  const onKeyUpCapture = (e) => {
    setSearchValue(e.currentTarget.value);
  };

  /**
   * Do something with the selection based on the found option with `checked: on`
   */
  const onChange = (updatedOptions) => {
    const clickedItem = updatedOptions.find((option) => option.checked === 'on');
    if (!clickedItem) return;
    setSuperSelectValue(clickedItem.typeSearch);
    setSearchText((prev) => {
      return clickedItem.label;
    });

    const inputElement = document.querySelector('.header-search-block input.euiFieldSearch');
    inputElement.focus();

    //
    onSearch(clickedItem.label, clickedItem.typeSearch);
  };

  const handleSearch = (e) => {
    let inputValue = e.target.value.trim();
    if (e.key === 'Enter' && inputValue !== '') {
      let historySearchData = JSON.parse(localStorage.getItem('historySearchJson')) || [];
      let typeSearchName = superSelectOptions.find((item) => {
        return item.value === superSelectvalue;
      });

      if (historySearch.every((item) => item.label !== inputValue)) {
        if (historySearch.length < 50) {
          // chỉ lưu tối đa 50 giá trị vào localstorage
          historySearchData.unshift({
            label: inputValue,
            typeSearch: superSelectvalue,
            icon: {
              type: 'clock',
              color: 'subdued',
            },
            meta: [
              {
                text: typeSearchName.inputDisplay,
              },
            ],
          });

          setHistorySearch((prev) => {
            return [
              ...prev,
              {
                label: inputValue,
                typeSearch: superSelectvalue,
                icon: {
                  type: 'clock',
                  color: 'subdued',
                },
                meta: [
                  {
                    text: typeSearchName.inputDisplay,
                  },
                ],
              },
            ];
          });
          localStorage.setItem('historySearchJson', JSON.stringify(historySearchData));
        } else {
          historySearchData.pop();
          historySearchData.unshift({
            label: inputValue,
            typeSearch: superSelectvalue,
            icon: {
              type: 'clock',
              color: 'subdued',
            },
            meta: [
              {
                text: typeSearchName.inputDisplay,
              },
            ],
          });

          setHistorySearch((prev) => {
            return [
              ...prev,
              {
                label: inputValue,
                typeSearch: superSelectvalue,
                icon: {
                  type: 'clock',
                  color: 'subdued',
                },
                meta: [
                  {
                    text: typeSearchName.inputDisplay,
                  },
                ],
              },
            ];
          });
          localStorage.setItem('historySearchJson', JSON.stringify(historySearchData));
        }
      }

      //
      onSearch();
    }
  };

  return (
    <>
      <EuiSuperSelect
        options={superSelectOptions}
        valueOfSelected={superSelectvalue}
        onChange={(value) => onSuperSelectChange(value)}
        compressed={true}
        itemLayoutAlign='top'
        hasDividers
        className='select-type-search'
      />
      <EuiSelectableTemplateSitewide
        className='header-search-block'
        isLoading={isLoading}
        onChange={onChange}
        options={searchValueExists ? searchData : recentsWithIcon}
        searchProps={{
          append: '',
          onKeyUpCapture: onKeyUpCapture,
          className: 'customSearchClass',
          inputRef: setSearchRef,
          value: searchText,
          placeholder: getMessage('pages.common.select.placeholder.select_search'),
        }}
        listProps={{
          className: 'customListClass',
        }}
        popoverProps={{
          className: 'customPopoverClass',
        }}
        popoverButton={<EuiButton>Search</EuiButton>}
        popoverButtonBreakpoints={['xs', 's']}
        popoverFooter={
          <EuiText color='subdued' size='xs'>
            <EuiFlexGroup alignItems='center' gutterSize='s' responsive={false} wrap>
              {/* <EuiFlexItem grow={false}>
                {searchValueExists && <EuiLink>View more results</EuiLink>}
              </EuiFlexItem>
              <EuiFlexItem /> */}
              <EuiFlexItem grow={false}>History of search</EuiFlexItem>
              {/* <EuiFlexItem grow={false}>
                <EuiBadge>Command + K</EuiBadge>
              </EuiFlexItem> */}
            </EuiFlexGroup>
          </EuiText>
        }
        style={{ minWidth: 300, height: '32px' }}
        onKeyUp={handleSearch}
        onInput={(e) => {
          localStorage.setItem('globalSearchText', e.target.value);
          setSearchText(e.target.value);
        }}
      />
    </>
  );
};
